import { BodyText, Col, Link, Row } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import styles from './styles';
import { PG_PHONE_NUMBER } from '../../constants';

const useStyles = createUseStyles(styles, { name: 'Footer' });

function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Row className={classes.centeredRow}>
        <Col className={classes.privacyCol} span={{ medium: 6, large: 4 }}>
          <p>
            <BodyText size="small" weight="bold" as="strong" className={classes.centeredText}>
              Your privacy & security are serious matters
            </BodyText>
          </p>
          <BodyText size="small" className={classes.centeredText}>
            Read our <Link href="/about/privacy">Privacy Pledge</Link> &{' '}
            <Link href="/about/terms">Terms of Service</Link>
          </BodyText>
        </Col>
        <Col className={classes.bbbCol} span={{ medium: 3, large: 2 }}>
          <img
            alt="BBB Accredited Business"
            src="https://static.policygenius.com/svgs/bbb.svgz"
            width="84px"
          />
        </Col>
        <Col span={{ small: 0, medium: 0, large: 6 }}>
          <Row nested>
            <Col className={classes.questionsCol} span={{ large: 8 }}>
              <p className={classes.centeredText}>
                <BodyText size="small" weight="bold" as="strong">
                  Questions?
                </BodyText>
              </p>
              <BodyText size="small" className={classes.centeredText}>
                Talk to a licensed Policygenius expert
              </BodyText>
              <BodyText size="small" className={classes.centeredText}>
                Available weekdays 9am-6pm EST
              </BodyText>
            </Col>
            <Col span={{ large: 4 }}>
              <BodyText size="small">
                Call{' '}
                <Link size="small" href={`tel:${PG_PHONE_NUMBER}`} variant="secondary">
                  {PG_PHONE_NUMBER}
                </Link>
              </BodyText>
            </Col>
          </Row>
        </Col>
      </Row>
    </footer>
  );
}

export default Footer;
